import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, CardContainerView2, GridCardPeopleView } from './styles';
import { Row } from '../PeopleListView/styles';
import { ImageUrl } from '../../utils/constants';
import _ from "lodash";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ParticipantLocationPopup from '../NewEmployeePopupV2/participantsLocation';
import LazyImage from '../common/LazyImage/LazyImage';
import { NewViewProfileIcon, wellnessChampionCardIcon } from "../../utils/icons";
import { cleanUpCommas, getInitials } from '../../utils/methods';
import { NameInitials } from '../Manager/styles';

class PeopleGridView extends Component {
  constructor() {
    super();
    this.state = {
      userId: null,
      initiativeId: null,
      initiativeName: null,
      employeeList: [],
      selectedParticipant: [],
      showNote: false,
      onHover: -1,
      showFallback: false,
    };
  }

  componentDidMount() {
    const arra = [];
    const { employeeList } = this.props;
    employeeList && employeeList.length && employeeList.map((obj) => {
      obj.select = false;
      arra.push(obj);
    });
    this.setState({ employeeList: arra });
    localStorage.setItem("selectedEmployeeList", JSON.stringify([]));
  }

  onHoverMouse = (id) => {
    this.setState({
      onHover: id
    });
  };

  onLeaveHoverMouse = () => {
    this.setState({
      onHover: -1
    });
  };

  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name
    });
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null
    });
  };

  activeTick = (index) => {
    let prev = this.state.employeeList;
    let newData = this.props.employeeList;
    let totalData = prev.concat(newData);
    let objIndex = totalData.findIndex(((obj) => obj.uid == index));
    const prevSelect = totalData[objIndex].select;
    totalData[objIndex].select = !prevSelect;
    let selectedArray = totalData.filter((obj) => obj.select === true);
    let unique = selectedArray.filter((item, index) => selectedArray.indexOf(item) === index);
    this.setState({
      employeeList: totalData,
      selectedParticipant: unique
    });
    localStorage.setItem("selectedEmployeeList", JSON.stringify(selectedArray));
  }

  fallBack = (e) => {
    e.target.src = '/public/images/default.png';
  }

  goToPersonalProfile = (employeeId) => {
    const { history } = this.props;
    history.push(`/company/people/${employeeId}/personal-profile`);
  }

  goToHealthCoachProfile = (employeeId) => {
    const { history } = this.props;
    history.push(`/health-coach/dashboard?employeeId=${employeeId}`);
  }

  capitalizeFirstLetter = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  styles = {
    cardMain: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      position: 'relative',
      padding: '0px',
      justifyContent: 'space-between'
    },
    topContent: {
      padding: '16px 8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1
    },
    topContentDeleted: {
      padding: '24px 8px 16px 8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1
    },
    imageContainer: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      overflow: 'hidden',
      marginBottom: '16px',
      position: 'relative',
      flexShrink: 0
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    checkbox: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      zIndex: 10
    },
    textContainer: {
      textAlign: 'center',
      marginBottom: '10px',
      width: '100%'
    },
    name: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#184A61',
      marginBottom: '8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    subText: {
      fontSize: '14px',
      color: '#184A61',
      marginBottom: '8px',
    },
    iconRow: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '0',
      marginBottom: '15px',
      minHeight: '30px',
      width: '100%'
    },
    iconImg: {
      width: '24px',
      height: '24px',
      filter: 'invert(55%) sepia(25%) saturate(600%) hue-rotate(170deg) brightness(90%) contrast(90%)'
    },
    // footer: {
    //   backgroundColor: '#F2F2F2',
    //   minHeight: '44px',
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'center',
    //   fontSize: '16px',
    //   color: '#184A61',
    //   fontWeight: '500',
    //   position: 'absolute',
    //   width: '94%',
    //   bottom: '16px',
    //   left: '8px',
    //   borderRadius: '4px',
    // },
    hoverOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(85, 85, 85, 0.95)',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 20
    },
    hoverBtn: {
      background: '#E97276',
      fontSize:'16px',
      color: '#fff',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontWeight: 'normal'
    },
    deletedBanner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: '600',
      textAlign: 'center',
      padding: '4px 5px',
      zIndex: 5
    }
  };

  render() {
    const { showEmployeeDetails, selectedEmployee, sendFriendRequestPost, searchAmigo, t, show, plp, employeeList, healthCoachRole } = this.props;
    const { userId, initiativeId, initiativeName, onHover } = this.state;
    window.console.log('show',show);
    let uidArray = [];
    this.state.selectedParticipant.map((obj) => {
      uidArray.push(obj.uid);
    });

    return (
      <Wrapper marginTop={"0px"} content="1">
        {!(_.isNull(employeeList)) && !(_.isUndefined(employeeList)) && employeeList.length > 0 ? (
          employeeList.map((employee, index) => {
            const isHovering = onHover === employee.uid;
            const isDeleted = employee.is_user_deleted && !searchAmigo && !healthCoachRole;

            let footerContent = null;
            let footerStyle = { ...this.styles.footer };

            if (searchAmigo) {
              if (employee.friend === 0) {
                footerStyle = { ...footerStyle, background: '#FD7175', color: 'white', cursor: 'pointer' };
                footerContent = t("Add Buddy");
              } else if (employee.friend === 1) {
                footerStyle = { ...footerStyle, background: 'rgb(159, 201, 137)', color: 'white' };
                footerContent = t("Buddies");
              } else if (employee.friend === 2) {
                footerStyle = { ...footerStyle, background: 'rgb(246, 180, 121)', color: 'white' };
                footerContent = t("Pending");
              } else {
                footerContent = "";
              }
            } else {
              // Priority Check: wellness_points (searchPeopleAdmin API) -> total_global_points -> total_wellness_point
              let points = 0;
              if (employee.wellness_points !== undefined && employee.wellness_points !== null) {
                points = employee.wellness_points;
              } else if (employee.total_global_points !== undefined && employee.total_global_points !== null) {
                points = employee.total_global_points;
              } else if (employee.total_wellness_point !== undefined && employee.total_wellness_point !== null) {
                points = employee.total_wellness_point;
              }

              footerContent = `${t("Wellness Points")} : ${points}`;
            }

            const interestList = healthCoachRole ? employee.welling_pillars : employee.interests;

            return (
              <CardContainerView2
                removeBorder
                key={index}
                marginRight={(index + 1) % 4 === 0 ? "0px" : "31px"}
                onClick={() => showEmployeeDetails(employee.uid)}
                active={selectedEmployee === employee.uid}
                style={{ borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', overflow: 'hidden' }}
              >
                <GridCardPeopleView
                  active={selectedEmployee === employee.uid}
                  deleted={employee.is_user_deleted && !searchAmigo}
                  background={isDeleted ? "#da6c74bd" : "transparent"}
                  cursor={0} // Ensure interactions are enabled even if user is deleted
                  style={{ 
                    minHeight: '270px', 
                    padding: '0px',
                    backgroundColor: isDeleted ? "#da6c74bd" : "transparent",
                    borderRadius: '10px'
                  }}
                >
                  <div
                    style={{
                      ...this.styles.cardMain,
                      backgroundColor: isDeleted ? "#da6c74bd" : "transparent",
                      borderRadius: '10px'
                    }}
                    onMouseEnter={() => this.onHoverMouse(employee.uid)}
                    onMouseLeave={() => this.onLeaveHoverMouse()}
                  >

                    {/* Hover Overlay - Now enabled for deleted users too */}
                    {isHovering ? (
                      <div style={this.styles.hoverOverlay}>
                        {/* <div style={{ ...this.styles.name, color: 'white', marginBottom: '5px' }}>
                          {t(this.capitalizeFirstLetter(employee.fname))} {t(this.capitalizeFirstLetter(employee.lname))}
                        </div>
                        <div style={{ color: 'white', marginBottom: '20px', fontSize: '14px' }}>
                          {employee.department ? t(employee.department) : ""}
                        </div> */}

                        <div
                          style={this.styles.hoverBtn}
                          onClick={(e) => {
                            e.stopPropagation();
                            healthCoachRole ? this.goToHealthCoachProfile(employee.uid) : this.goToPersonalProfile(employee.uid);
                          }}
                        >
                          <div style={{ marginRight: '8px', display: 'flex' }}><NewViewProfileIcon fill="#fff" /></div>
                          {t("View Profile")}
                        </div>
                      </div>
                    ):null}

                    {/* Deleted User Banner */}
                    {isDeleted ? (
                      <div style={this.styles.deletedBanner}>
                        {t("User will be removed end of Month")}
                      </div>
                    ):null}

                    <div style={isDeleted ? this.styles.topContentDeleted : this.styles.topContent}>
                      {show && (
                        <div style={this.styles.checkbox} onClick={(e) => { e.stopPropagation(); this.activeTick(employee.uid); }}>
                          <div style={{
                            width: '24px', height: '24px',
                            border: uidArray.includes(employee.uid) ? 'none' : '1px solid #005C87',
                            borderRadius: '21px', display: "flex", justifyContent: "center", alignItems: "center",
                            backgroundColor: 'white'
                          }}>
                            {uidArray.includes(employee.uid) ? <img src={ImageUrl + '/ChallengeDetailsScreen/updatedCheckmark.svg'} alt="checked" />:null}
                          </div>
                        </div>
                      )}

                      {(!healthCoachRole && !isDeleted && employee.is_champion) ? (
                        <div className="championIcon" style={{ position: 'absolute', top: 10, left: 10 }}>
                          {wellnessChampionCardIcon()}
                        </div>
                      ):null}

                      <div style={this.styles.imageContainer}>
                        {employee.profile_image === 'profile-Image/default.png' || !employee.profile_image ?
                          <NameInitials id="name-initials" isBg={"#FEFEFE"} style={{ width: '100%', height: '100%', fontSize: '24px' }}>
                            {getInitials(employee?.fname + " " + employee?.lname)}
                          </NameInitials>
                          :
                          <LazyImage onError={this.fallBack} src={`${ImageUrl}/${employee.profile_image}`} style={this.styles.img} />
                        }
                      </div>

                      <div style={this.styles.textContainer}>
                        <div style={{
                          ...this.styles.name,
                          color: isDeleted ? '#FFFFFF' : '#184A61'
                        }}>
                          {t(this.capitalizeFirstLetter(employee.fname))} {t(this.capitalizeFirstLetter(employee.lname))}
                        </div>
                        <div style={{
                          ...this.styles.subText,
                          color: isDeleted ? '#FFFFFF' : '#184A61'
                        }}>
                          {employee.department ? t(employee.department) : "-"}
                        </div>
                        <div style={{
                          ...this.styles.subText,
                          color: isDeleted ? '#FFFFFF' : '#184A61'
                        }}>
                          {employee.location ? t(cleanUpCommas(employee.location)) : "-"}
                        </div>
                      </div>

                      <div style={this.styles.iconRow}>
                        {interestList && interestList.length > 0 ? (
                          interestList.slice(0, 5).map((item, i) => {
                            const iconPath = healthCoachRole ? item.icon : item.interest_icon;
                            const id = healthCoachRole ? item.pillar_id : item.interest_id;
                            const title = healthCoachRole ? item.pillar_title : item.interest_name;

                            return (
                              <div key={i} style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
                                onMouseEnter={() => this.onEnterMouse(employee.uid, id, title)}
                                onMouseLeave={() => this.onLeaveMouse()}>

                                <img
                                  src={`${ImageUrl}/${iconPath}`}
                                  alt={title}
                                  style={{
                                    ...this.styles.iconImg,
                                    filter: isDeleted 
                                      ? 'brightness(0) invert(1)' 
                                      : 'invert(55%) sepia(25%) saturate(600%) hue-rotate(170deg) brightness(90%) contrast(90%)'
                                  }}
                                  onError={(e) => { e.target.style.display = 'none'; }}
                                />

                                {userId === employee.uid && initiativeId === id &&
                                  <div className="hover-card" style={{ position: 'absolute', bottom: '35px', left: '-20px', background: '#fff', padding: '4px 8px', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)', zIndex: 5, fontSize: '10px', whiteSpace: 'nowrap', color: '#000' }}>
                                    <div>{t(initiativeName)}</div>
                                  </div>}
                              </div>
                            );
                          })
                        ) : (
                          <div style={{ height: '24px' }}></div>
                        )}
                      </div>

                      {searchAmigo && employee.mutual_friends && employee.mutual_friends.length > 0 && (
                        <div style={{ fontSize: '12px', color: isDeleted ? '#FFFFFF' : '#999', marginBottom: '5px' }}>
                          {t("Mutual Buddy")}: {employee.mutual_friends.length}
                        </div>
                      )}
                    </div>

                    <div
                      style={footerStyle}
                      onClick={searchAmigo && employee.friend === 0 ? () => sendFriendRequestPost(employee.uid) : undefined}
                    >
                      <div style={{display:'none'}}>{footerContent}</div>
                    </div>

                  </div>
                </GridCardPeopleView>
              </CardContainerView2>
            );
          })
        ) : (
          <Row isFontSize={healthCoachRole ? "24px" : ""} disableCursor={1} align={1} upperBoxShadow="2px solid rgba(0,0,0,0.08)">
            {t("No Employee")}
          </Row>
        )}

        {!searchAmigo &&
          <ParticipantLocationPopup
            companyId={plp.companyId}
            fetchEditLocationApi={plp.fetchEditLocationApi}
            show={plp.show}
            departmentData={plp.departmentData}
            handleShowNote={plp.handleShowNote}
            data={plp.data}
            showModalPopUp={plp.showModalPopUp}
            selectedParticipant={this.state.selectedParticipant}
            companyAuthDetails={plp.companyAuthDetails}
          />
        }
      </Wrapper>
    );
  }
}

PeopleGridView.propTypes = {
  employeeList: PropTypes.array.isRequired,
  showEmployeeDetails: PropTypes.func.isRequired,
  selectedEmployee: PropTypes.any,
  searchAmigo: PropTypes.bool,
  history: PropTypes.object,
  t: PropTypes.func,
  sendFriendRequestPost: PropTypes.func,
  show: PropTypes.bool,
  plp: PropTypes.object,
  healthCoachRole: PropTypes.bool
};

const mapStateToProps = (state) => ({
  sentRequest: state.social.sentRequest
});

export default connect(mapStateToProps, null)(withTranslation()(PeopleGridView));